import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { KJUR } from "jsrsasign";

import settings from "../../constants/settings";

const METABASE_SITE_URL = settings.services.metabaseHOST;
const METABASE_SECRET_KEY = settings.services.metabaseDASHBOARD;
const METABASE_CUSTOMER_DASHBOARD = settings.services.metabaseCUSTOMERDASHBOARD;
const METABASE_ROMBO_DASHBOARD = settings.services.metabaseROMBODASHBOARD;

const Dashboard = (props) => {
  document.title = "Admin Web Dashboard";

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
    })
  );

  const { data } = useSelector(LoginProperties);
  if (!data || !data.data) {
    return <div>Cargando dashboard...</div>;
  }

  const partner_id = data.data.is_staff ? "4639" : data.data.partner_id;
  
  const dashboardId = data.data.is_staff
    ? Number(METABASE_ROMBO_DASHBOARD)
    : Number(METABASE_CUSTOMER_DASHBOARD);

  const payload = {
    resource: { dashboard: dashboardId },
    params: { partner_id },
    exp: Math.round(Date.now() / 1000) + 10 * 60, 
  };

  const header = { alg: "HS256", typ: "JWT" };
  const token = KJUR.jws.JWS.sign(
    "HS256",
    JSON.stringify(header),
    JSON.stringify(payload),
    { utf8: METABASE_SECRET_KEY }
  );

  const iframeUrl = `${METABASE_SITE_URL}/embed/dashboard/${token}#background=false&bordered=false&titled=true&refresh=60`;

  return (
    <Fragment>
      <iframe
        src={iframeUrl}
        width="100%"
        height="1000px"
        title="Metabase Dashboard"
      />
    </Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default Dashboard;
